import { ReactNode, createContext, useContext } from "react";
import { useComplexState } from "use-complex-state";
import { CatalogPourbackReducer } from "./CatalogPourbackReducer";

const CatalogPourbackContext = createContext({
  state: CatalogPourbackReducer.getInitialState(),
  actions: CatalogPourbackReducer.actions,
});

export const useCatalogPourbackContext = () =>
  useContext(CatalogPourbackContext);

export const CatalogPourbackProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [state, actions] = useComplexState({
    initialState: CatalogPourbackReducer.getInitialState(),
    reducers: CatalogPourbackReducer.caseReducers,
  });
  return (
    <CatalogPourbackContext.Provider value={{ state, actions }}>
      {children}
    </CatalogPourbackContext.Provider>
  );
};
